import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import Mobile from './mobile';
import Web from './web';
import style from './style.css';
import { onChange } from '../../../controller/theme_checkout';
import common from '../../../common/common';
import { locale } from '../../../utils/i18n';

class JSCheckout extends Component {
  constructor(props) {
    super(props);
  }

  onPreviewToggle = (label, value) => {
    if (this.props && this.props.onPreviewToggle) {
      common.log('onPreviewChange', label);
      this.props.onPreviewToggle(value);
    }
  };

  render({ isMobilePreviewSelected, selected }) {
    const merchantLogoUrl = selected.merchant && selected.merchant.merchantLogoUrl ? selected.merchant.merchantLogoUrl : null
    
    return (
      <section>
        <div className={`${style['view-tab']}`}>
          <ul className={`${style['view-list']}`}>
            <li
              className={`${style['view-item']} ${style[!isMobilePreviewSelected ? 'active' : '']}`}
              onClick={this.onPreviewToggle.bind(this, 'Web', false)}
            >
              {locale('checkout.web')}
            </li>
            <li
              className={`${style['view-item']} ${style[isMobilePreviewSelected ? 'active' : '']}`}
              onClick={this.onPreviewToggle.bind(this, 'Mobile', true)}
            >
              {locale('checkout.mobile')}
            </li>
          </ul>
        </div>
        {!isMobilePreviewSelected && selected.web && (
          <Web themeColor={selected.web} gradientColor={selected.gradient} selectedTheme={selected.web.NAME} merchantLogoUrl={merchantLogoUrl} />
        )}
        {isMobilePreviewSelected && selected.mobile && (
          <Mobile themeColor={selected.mobile} gradientColor={selected.gradient} selectedTheme={selected.mobile.NAME} merchantLogoUrl={merchantLogoUrl} />
        )}
      </section>
    );
  }
}

export default connect(
  'isMobilePreviewSelected, selected',
  onChange
)(JSCheckout);



// WEBPACK FOOTER //
// ./checkout/components/jscheckout/index.js